import { createSlice } from '@reduxjs/toolkit';

import { thunks } from './thunks';
import { selectors } from './selectors';
import { status } from 'utils/const';

const initialState = {
  classes: [],
  currentClass: null,
  nextAppointment: [],
  prevAppointment: [],

  currentClassLoadStatus: status.IDLE,
  nextAppointmentLoadStatus: status.IDLE,
  prevAppointmentLoadStatus: status.IDLE,
};

const slice = createSlice({
  name: 'classes',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(thunks.getClasses.fulfilled, (state, action) => {
        state.classes = action.payload?.data;
      })

      .addCase(thunks.getClassroom.pending, (state) => {
        state.currentClassLoadStatus = status.PENDING;
      })
      .addCase(thunks.getClassroom.fulfilled, (state, action) => {
        state.currentClass = action.payload?.data;
        state.currentClassLoadStatus = status.SUCCESS;
      })
      .addCase(thunks.getClassroom.rejected, (state) => {
        state.currentClassLoadStatus = status.FAIL;
      })
      .addCase(thunks.getNextAppointment.pending, (state) => {
        state.nextAppointmentLoadStatus = status.PENDING;
      })
      .addCase(thunks.getNextAppointment.fulfilled, (state, action) => {
        state.nextAppointment = action.payload?.data;
        state.nextAppointmentLoadStatus = status.SUCCESS;
      })
      .addCase(thunks.getNextAppointment.rejected, (state) => {
        state.nextAppointmentLoadStatus = status.FAIL;
      })
      .addCase(thunks.getPrevAppointment.pending, (state) => {
        state.prevAppointmentLoadStatus = status.PENDING;
      })
      .addCase(thunks.getPrevAppointment.fulfilled, (state, action) => {
        state.prevAppointment = action.payload?.data;
        state.prevAppointmentLoadStatus = status.SUCCESS;
      })
      .addCase(thunks.getPrevAppointment.rejected, (state) => {
        state.prevAppointmentLoadStatus = status.FAIL;
      });
  },
});

const classes = {
  actions: slice.actions,
  thunks,
  selectors,
};

export { classes };
export default slice.reducer;
